module.exports = __webpack_public_path__ + "static/media/young-girl-with-fringe.34974172.svg";